import gql from 'graphql-tag'

export {
  SchoolTuitionProgramFields as ITuitionProgram,
  SchoolTuitionProgramFields_priceOptions as IPriceOption,
} from './__generated__/SchoolTuitionProgramFields'

export const SchoolTuitionProgramFieldsFragment = gql`
  fragment SchoolTuitionProgramFields on SchoolTuitionProgram {
    id
    name
    ageMonthsMin
    ageMonthsMax
    hoursStart
    hoursEnd
    isRegularStart
    isRegularEnd
    priceOptions {
      daysPerWeek
      monthlyRate
      weeklyRate
      hidden
    }
  }
`
